import type { UserCartItem } from '@/hooks/use-user-global-cart';
import type { AppliedVoucher } from '@/types/voucher';

/**
 * The discount the applied voucher grants on a specific set of cart rows.
 *
 * The session voucher records `total_discount_amount` across every row that
 * matched when the code was entered, but the buyer only pays for the rows they
 * selected — on the "Mua ngay" path the cart can hold unrelated items entirely.
 * Summing per selection keeps the "Giảm giá" line consistent with the "Tổng cộng"
 * line, which is itself a sum over the selected rows only.
 *
 * Mirrors `VoucherMatchingService::calculateDiscountAmount()`: the percentage is
 * taken against the undiscounted `price * qty`, which is what the cart JSON's
 * `price` field carries.
 */
export function calcScopedDiscount(items: UserCartItem[], voucher?: AppliedVoucher | null): number {
  const percent = voucher?.discount_percent ?? 0;
  if (!voucher || percent <= 0) return 0;

  const matchedRowIds = new Set(voucher.matched_row_ids ?? []);
  const base = items.filter((item) => matchedRowIds.has(item.rowId)).reduce((sum, item) => sum + item.price * item.qty, 0);

  return Math.round(((base * percent) / 100) * 100) / 100;
}
